module.exports = "https://cdn2-fs.clearscore.com/flux/images/1a25fedf5fb8c9b957c1eb0d720d31ed.jpg";